import React, { useEffect, useState } from 'react'

import { PaperworkItem } from '../../paperwork/component/PaperworkItem'
import customImageComponent from '../../../components/common/CustomImageComponent'
import LightboxCommonComponent from '../../../components/common/dialogs/full-screen/LightboxCommonComponent'

import { signedStatuses } from '../../../const/data/v01/rider-team-members/firestore-v01-rider-team-member-const'
import { calculateAge } from '../../../models/interface.helper'
import { getFilteredPaperwork } from '../../../helpers/documents'

import { IPaperworkTeam } from '../../../models/user-documents/user-documents.interface'
import { ILightboxProps } from '../../../types/competitor_types'
import { IEventReviewPublish } from '../../../models/event-review-publish/event-review-publish.interface'

const openNextSibbling = (e: any) => {
  e.target?.closest('.accordion')?.nextElementSibling?.classList.toggle('activeTab')
}

export const AccordionWrapper = ({
  type,
  handleToggle,
  openedMenu,
  teamMemberIndex,
  userData,
  eventReviewPublish,
}: {
  type?: 'overview' | 'registrar'
  handleToggle: (value: number) => void
  openedMenu: number[]
  teamMemberIndex: number
  userData: IPaperworkTeam | null
  eventReviewPublish: IEventReviewPublish | null
}) => {
  const [lightBox, setLightBox] = useState<ILightboxProps>({ visible: false, slides: [] })
  const [signMissing, setSignMissing] = useState(0)

  useEffect(() => {
    if (userData && userData.documents) {
      const notSigned = userData.documents.filter(
        (document) => document.status === signedStatuses.SIGNED
      )
      const filteredPaperworkDocuments = getFilteredPaperwork(
        eventReviewPublish?.EventPaperwork ?? null
      )

      setSignMissing(filteredPaperworkDocuments.length - notSigned.length)
    }
  }, [userData, eventReviewPublish?.EventPaperwork])

  let age = calculateAge(userData?.teamMemberDob)

  return (
    <>
      <div className="border-[#D3DAEE] border-t py-4">
        <div
          onClick={(e: any) => {
            openNextSibbling(e)
            handleToggle(teamMemberIndex)
          }}
          className="text-SeabiscuitDark200ThemeColor flex flex-col lg:flex-row lg:justify-between lg:items-center font-semibold accordion cursor-pointer"
        >
          <div className="flex items-center">
            <span className="w-[45px] h-[45px] rounded-md border overflow-hidden mr-4">
              {customImageComponent(
                userData?.teamMemberProfilePicture,
                userData?.teamMemberName,
                'w-full h-full object-cover'
              )}
            </span>
            <div className="flex flex-col">
              <span className="text-md text-black font-semibold capitalize">
                {userData?.teamMemberName ?? 'N/A'}
              </span>{' '}
              <div className="font-normal text-xs text-black/50">
                {userData?.teamMemberRole ?? 'N/A'},{' '}
                { userData?.documents?.[0]
                  ? signMissing === 0
                    ? 'All signed'
                    : `${signMissing} ${signMissing === 1 ? 'signature' : 'signatures'} missing`
                  : 'No paperwork'}
              </div>
            </div>
          </div>
          <div className="flex justify-between mt-3 lg:mt-0 items-center">
            {age < 18 && (
              <span className="mr-2 font-normal bg-[#122B461A] text-[#122B46] text-[10px] px-2 text-center min-w-[60px] py-1 rounded-[20px]">
                Minor
              </span>
            )}
            {userData?.documents && userData?.documents?.length > 0 && (
              <div className="status text-SeabiscuitGreenThemeColor rounded-full p pl-4 pr-1 add_icon cursor-pointer">
                {openedMenu.includes(teamMemberIndex) ? (
                  <div className={'add_icon cursor-pointer'}>
                    <img src={'/assets/og_icons/CloseArrow.svg'} alt="Close" />
                  </div>
                ) : (
                  <div className={'remove_icon cursor-pointer'}>
                    <img src={'/assets/og_icons/OpenArrow.svg'} alt="Open" />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="faqs-content">
          {userData?.documents?.[0] && (
            <div className="flex flex-wrap gap-x-[1%] gap-y-4 my-4">
              {userData?.documents?.map((doc, index) => (
                <PaperworkItem
                  key={index}
                  doc={doc}
                  type={type}
                  allDocs={userData?.documents ?? []}
                  setLightBox={setLightBox}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* -----------LightBox----------- */}
      <LightboxCommonComponent
        visible={lightBox.visible}
        onClose={() => setLightBox({ visible: false, slides: [] })}
        slides={lightBox.slides}
      />
    </>
  )
}
